import React, { PropsWithChildren, useState } from "react";
import styled from "styled-components";
import { TypographyNew } from "../../product/global/typography/typography";
import { useBreakpoint } from "../../product/utils/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";

export const Heading = styled(TypographyNew)`
  font-weight: bold;
  margin: 10px 0;
  font-size: 14px;
`;

const Icon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 30px;
`;

const FooterLinks = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>): JSX.Element => {
  const { isDesktop } = useBreakpoint();
  const [isOpen, setIsOpen] = useState(isDesktop);
  const onClick = () => {
    if (!isDesktop) {
      setIsOpen(!isOpen);
    }
  };
  return (
    <>
      <Heading onClick={onClick}>
        {title}
        {!isDesktop && (
          <Icon size="sm" icon={isOpen ? faChevronDown : faChevronRight} />
        )}
      </Heading>
      {(isOpen || isDesktop) && children}
    </>
  );
};

export default FooterLinks;
